var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { align: "center" } },
    [
      _c(
        "v-flex",
        { attrs: { md10: "" } },
        [
          _c(
            "v-card",
            { staticClass: "rounded-card" },
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  staticClass: "col-md-12",
                  attrs: { "lazy-validation": "" }
                },
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "", "text-xs-center": "" } },
                    [
                      _c("StepTitle", [_vm._v("Configurar Notificación")]),
                      _c("v-divider"),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { sm12: "", md6: "" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.lstTipoNotificacion,
                                  "item-text": "value",
                                  "item-value": "id"
                                },
                                on: { change: _vm.handledTipoNotificacion },
                                model: {
                                  value: _vm.tipoNotificacion,
                                  callback: function($$v) {
                                    _vm.tipoNotificacion = $$v
                                  },
                                  expression: "tipoNotificacion"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm6: "", md6: "" } },
                            [
                              _c("BuscadorOperacionCrud", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.tipoNotificacion == 1,
                                    expression: "tipoNotificacion == 1"
                                  }
                                ],
                                attrs: {
                                  filter:
                                    _vm.gridApiListaDistribucion &&
                                    _vm.gridApiListaDistribucion.setQuickFilter.bind(
                                      _vm.gridApiListaDistribucion
                                    )
                                }
                              }),
                              _c("BuscadorOperacionCrud", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.tipoNotificacion == 2,
                                    expression: "tipoNotificacion == 2"
                                  }
                                ],
                                attrs: {
                                  filter:
                                    _vm.gridApiContacto &&
                                    _vm.gridApiContacto.setQuickFilter.bind(
                                      _vm.gridApiContacto
                                    )
                                }
                              }),
                              _c("BuscadorOperacionCrud", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.tipoNotificacion == 3,
                                    expression: "tipoNotificacion == 3"
                                  }
                                ],
                                attrs: {
                                  filter:
                                    _vm.gridApiUsuario &&
                                    _vm.gridApiUsuario.setQuickFilter.bind(
                                      _vm.gridApiUsuario
                                    )
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md12: "" } },
                            [
                              _c(
                                "v-card",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.tipoNotificacion == 1,
                                      expression: "tipoNotificacion == 1"
                                    }
                                  ]
                                },
                                [
                                  !_vm.modoVer
                                    ? _c("AsociacionGrid", {
                                        attrs: {
                                          esEditar: _vm.modoEditar,
                                          headerCheckbox: true,
                                          "grid-options":
                                            _vm.gridOptionsListaDistribucion
                                        }
                                      })
                                    : _c("MantenedorGridVerDetalle", {
                                        attrs: {
                                          "grid-options":
                                            _vm.gridOptionsListaDistribucion,
                                          "row-data":
                                            _vm.lstDistribucionSeleccionada
                                        }
                                      })
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.tipoNotificacion == 2,
                                      expression: "tipoNotificacion == 2"
                                    }
                                  ]
                                },
                                [
                                  !_vm.modoVer
                                    ? _c("AsociacionGrid", {
                                        attrs: {
                                          esEditar: _vm.modoEditar,
                                          headerCheckbox: true,
                                          "grid-options":
                                            _vm.gridOptionsContacto
                                        }
                                      })
                                    : _c("MantenedorGridVerDetalle", {
                                        attrs: {
                                          "grid-options":
                                            _vm.gridOptionsContacto,
                                          "row-data":
                                            _vm.lstContactosSeleccionada
                                        }
                                      })
                                ],
                                1
                              ),
                              _c(
                                "v-card",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.tipoNotificacion == 3,
                                      expression: "tipoNotificacion == 3"
                                    }
                                  ]
                                },
                                [
                                  !_vm.modoVer
                                    ? _c("AsociacionGrid", {
                                        attrs: {
                                          esEditar: _vm.modoEditar,
                                          headerCheckbox: true,
                                          "grid-options":
                                            _vm.gridOptionsUsuarios
                                        }
                                      })
                                    : _c("MantenedorGridVerDetalle", {
                                        attrs: {
                                          "grid-options":
                                            _vm.gridOptionsUsuarios,
                                          "row-data":
                                            _vm.lstUsuariosSeleccionados
                                        }
                                      })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-container",
                    { staticStyle: { padding: "10px 10px 10px 10px" } },
                    [
                      _c(
                        "FormFieldsContainer",
                        { attrs: { titulo: "Medio de Notificación" } },
                        [
                          _vm._t("prependMedioNotificacion"),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "", md4: "" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: _vm.formFields.notificaGps.label,
                                  "data-vv-name": _vm.formFields.notificaGps.id,
                                  disabled: _vm.modoVer
                                },
                                model: {
                                  value: _vm.formFields.notificaGps.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.notificaGps,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.notificaGps.value"
                                }
                              })
                            ],
                            1
                          ),
                          !_vm.isFuga
                            ? _c(
                                "v-flex",
                                { attrs: { xs12: "", sm4: "", md4: "" } },
                                [
                                  _c("v-checkbox", {
                                    attrs: {
                                      label:
                                        _vm.formFields.notificaBrowser.label,
                                      "data-vv-name":
                                        _vm.formFields.notificaBrowser.id,
                                      disabled: _vm.modoVer
                                    },
                                    model: {
                                      value:
                                        _vm.formFields.notificaBrowser.value,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.formFields.notificaBrowser,
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "formFields.notificaBrowser.value"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm4: "", md4: "" } },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  label: _vm.formFields.notificaEmail.label,
                                  "data-vv-name":
                                    _vm.formFields.notificaEmail.id,
                                  disabled: _vm.modoVer || _vm.isFuga
                                },
                                model: {
                                  value: _vm.formFields.notificaEmail.value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.formFields.notificaEmail,
                                      "value",
                                      $$v
                                    )
                                  },
                                  expression: "formFields.notificaEmail.value"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "", "text-xs-center": "" } },
                    [
                      _c("StepTitle", [_vm._v("Calendario")]),
                      _c("v-divider"),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              attrs: {
                                xs12: "",
                                sm6: "",
                                md2: "",
                                "offset-xs10": "",
                                "align-end": ""
                              }
                            },
                            [
                              !_vm.modoVer
                                ? _c("AgregarButton2", {
                                    on: {
                                      click: function($event) {
                                        return _vm.handleCrearCalendario()
                                      }
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md12: "" } },
                            [
                              _c(
                                "v-card",
                                [
                                  !_vm.modoVer
                                    ? _c("AsociacionGrid", {
                                        attrs: {
                                          esEditar: _vm.modoEditar,
                                          headerCheckbox: false,
                                          "grid-options":
                                            _vm.gridOptionsCalendario
                                        }
                                      })
                                    : _c("MantenedorGridVerDetalle", {
                                        attrs: {
                                          "grid-options":
                                            _vm.gridOptionsCalendario,
                                          "row-data":
                                            _vm.lstCalendarioSeleccionado
                                        }
                                      })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("CrearCalendarioModal", {
        attrs: { show: _vm.mostrarModalCalendario },
        on: {
          cerrar: _vm.handleCierreModal,
          nuevoCalendario: _vm.handleNuevoCalendario
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }